module.exports = __webpack_public_path__ + "static/img/radianceImage.16e1b9e6.png";